import __request__ from "routing/request";
export function get(nodeId, requestOptions) {
  return __request__("GET", `/cluster/${nodeId}/journal`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
